import { DataPair } from "../../types";

export interface ProductionCodeRequestListPayload {
  pib: string | null;
  datum: string[] | null;
  robnaMarkaId: number | null;
  brojZahteva: string | null;
}

export interface ProductionCodeRequestFormPayload {
  oznakaKn: string;
  masinaId: number | null;
  objekatId: number | null;
  ukljuceneMasine: boolean;
  robnaMarkaId: number | null;
  tipObveznikaId: number | null;
  duvanskiProizvodVrstaId: number | null;
  brojCigaretaUPojedinacnomPakovanju: number | null;
  prosecnaBrutoMasaJedinicnogPakovanja: number | null;
  trazenaKolicinaJedinstvenihOznakaPojedinacnogPakovanja: number | null;
  brojZahteva: string | null;
  placen: boolean | null;
}

export interface CreateProductionCodeResponse {
  id: number;
  brojZahteva: string;
  sifraRobneMarke: string;
}

export interface DownloadProductionCodeRequestFilePayload {
  zahtevId: number | null;
  docName: string | null;
  sifraRobneMarke: string | null;
}

export enum ProductionCodeRequestStatus {
  KREIRAN = 1,
  ODBIJEN,
  PRIHVACEN,
  U_OBRADI,
}

export interface ProductionCodeRequest {
  id: number;
  pib: string;
  objekat: string;
  drustvo: string;
  robnaMarka: string;
  brojZahteva: string;
  datumKreiranjaZahteva: string;
  trazenaKolicina: number | null;
  status: string;
  statusId: ProductionCodeRequestStatus;
  sifraRobneMarke: string;
  placen: boolean | null;
}

export interface ProductionCodeObject {
  naziv: string;
  id: number | null;
  masine: DataPair[];
}

export interface ProductionCodeRequestFormData {
  objekti: ProductionCodeObject[];
  tipObveznika: DataPair[];
  vrstaProizvoda: DataPair[];
}

export interface ProductionCodeRequestDetails
  extends ProductionCodeRequestFormPayload {
  masineNaziv: string;
  objekatNaziv: string;
  robnaMarkaNaziv: string;
  tipObveznika: string;
  note: string | null;
  status: string | null;
  statusId: ProductionCodeRequestStatus;
  zahtevId: number | null;
  sifraRobneMarke: string | null;
  placen: boolean;
}

export interface ProductionCodeRequestApprovalPayload {
  note: string;
  zahtevId: number | null;
}
export interface ProdukcioniKodIzvod {
  id: number;
  brojZahteva: string;
  datumIzvoda: string;
  brojIzvoda: string;
  uplatilac: string;
  pozivNaBroj: string;
  iznos: number;
}

export interface ProdukcioniKodIzvodResponse {
  list: Array<ProdukcioniKodIzvod>;
  total: number;
}

export interface ProdukcioniKodIzvodPayload {
  datum: string[] | null;
  brojZahteva: string | null;
  pozivNaBroj: string | null;
  pageNumber: number | null;
  pageSize: number | null;
}
